import { SELECTED_OBJECTS_PARAM } from '../../DataTables/hooks/useSelectedRowsFromSearchParams'
import { SELECT_AND_LINK_PARAM } from '../SelectAndLink.constants'
import { SelectAndLinkSession } from '../SelectAndLink.types'

export function buildSelectAndLinkIframeUrl(
  session: SelectAndLinkSession
): string {
  const targetSitemodel =
    session.targetPath || window.selectAndLinkFilterSitemodel
  const url = window.origin + `/${targetSitemodel}`
  const parsedUrl = new URL(url)
  const optionsForUrl = session.urlSelectedOptions ?? session.selectedOptions
  const minimalOptions = optionsForUrl?.length
    ? optionsForUrl.map((opt) => ({ uuid: opt.uuid }))
    : undefined

  const searchParams = new URLSearchParams(parsedUrl.search)

  searchParams.set('uuid_objectclass', session.objectclassUuid)
  searchParams.set(SELECT_AND_LINK_PARAM, '')
  if (session.uniselection) {
    searchParams.set('uniselection', '')
  }

  if (minimalOptions?.length) {
    searchParams.set(SELECTED_OBJECTS_PARAM, JSON.stringify(minimalOptions))
  }

  return `${parsedUrl.origin}${parsedUrl.pathname}?${searchParams.toString()}`
}
